export const loggedInDeviceData = [
  {
    id: '1',
    user: {
      name: 'Bennie Buckridge',
      email: 'Abner.Purdy@gmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-09.webp',
    },
    email: 'Brycen_Cremin44@hotmail.com',
    status: 'Offline',
    teams: ['Operations'],
  },
  {
    id: '2',
    user: {
      name: 'Philip Muller',
      email: 'Modesto_Marks@gmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-07.webp',
    },
    email: 'Hazle_Little10@hotmail.com',
    status: 'Offline',
    teams: ['Operations'],
  },
  {
    id: '3',
    user: {
      name: 'Viola Terry',
      email: 'Darlene17@gmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-10.webp',
    },
    email: 'Jovany57@gmail.com',
    status: 'Offline',
    teams: ['Design'],
  },
  {
    id: '4',
    user: {
      name: 'Emilio Towne',
      email: 'Alvah21@hotmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-11.webp',
    },
    email: 'Daniela88@hotmail.com',
    status: 'Active',
    teams: ['Software Engineering'],
  },
  {
    id: '5',
    user: {
      name: 'Shawn Bashirian',
      email: 'Joanne_Price43@gmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-06.webp',
    },
    email: 'Susana_Thiel60@hotmail.com',
    status: 'Active',
    teams: ['Product', 'Operations'],
  },
  {
    id: '6',
    user: {
      name: 'Darla Schaefer',
      email: 'Yasmin.Wiegand52@hotmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-15.webp',
    },
    email: 'Zion_Wehner@yahoo.com',
    status: 'Active',
    teams: ['Software Engineering', 'Human Resource'],
  },
  {
    id: '7',
    user: {
      name: 'Marcella Walter',
      email: 'Irma51@yahoo.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-04.webp',
    },
    email: 'Americo.Stamm78@yahoo.com',
    status: 'Offline',
    teams: ['Operations'],
  },
  {
    id: '8',
    user: {
      name: 'Dr. Sheri Collier',
      email: 'Abraham.Stiedemann59@yahoo.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-11.webp',
    },
    email: 'Brown2@gmail.com',
    status: 'Active',
    teams: ['Software Engineering', 'Human Resource'],
  },
  {
    id: '9',
    user: {
      name: 'Luz Sawayn',
      email: 'Rashawn_Schowalter@gmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-07.webp',
    },
    email: 'Amina.Treutel@hotmail.com',
    status: 'Offline',
    teams: ['Operations', 'Human Resource'],
  },
  {
    id: '10',
    user: {
      name: 'Martha Smith-Marquardt',
      email: 'Demarco_Conroy@yahoo.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-02.webp',
    },
    email: 'Alberta.Medhurst@yahoo.com',
    status: 'Active',
    teams: ['Product'],
  },
  {
    id: '11',
    user: {
      name: 'Pablo Shanahan',
      email: 'Jaclyn.Hodkiewicz76@hotmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-01.webp',
    },
    email: 'Dee25@yahoo.com',
    status: 'Offline',
    teams: ['Product', 'Human Resource'],
  },
  {
    id: '12',
    user: {
      name: 'Forrest Feil',
      email: 'Domenica49@yahoo.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-15.webp',
    },
    email: 'Nicolette54@hotmail.com',
    status: 'Active',
    teams: ['Operations', 'Software Engineering'],
  },
  {
    id: '13',
    user: {
      name: 'Sharon Boehm',
      email: 'Marianna_Metz@hotmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-12.webp',
    },
    email: 'Claudine_Graham@gmail.com',
    status: 'Active',
    teams: ['Product'],
  },
  {
    id: '14',
    user: {
      name: 'Jimmie Bergstrom',
      email: 'Jarrett69@yahoo.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-03.webp',
    },
    email: 'Alfonso78@yahoo.com',
    status: 'Offline',
    teams: ['Operations', 'Human Resource'],
  },
  {
    id: '15',
    user: {
      name: 'Eleanor Mante',
      email: 'Tamia.Jerde@gmail.com',
      avatar:
        'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-13.webp',
    },
    email: 'Loma_Legros13@yahoo.com',
    status: 'Offline',
    teams: ['Product', 'Finance'],
  },
];
